var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('Navbar'),_c('Cookiebar'),_c('router-view'),_c('div',{staticStyle:{"height":"160px"}}),_c('Footer')],1),_c('Snackbar'),_c('FloatingCart')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }